import React from "react";

import routes, { SubRoute } from "Routes";
import { Route, Switch } from "react-router-dom";

import { useUser } from "@ip-contexts/user-context";
import { Page } from "@ip-partials";

type Props = {
  children: any;
  path: string;
};

export default function ProtectedRoutes({ children, path }: Props) {
  const {
    state: { user },
  } = useUser();

  const filterByRole = (subRouteFilteredByPath: SubRoute[]) => {
    const res: SubRoute[] = [];
    if (subRouteFilteredByPath) {
      for (const subRoute of subRouteFilteredByPath) {
        if (subRoute.roles) {
          let hasSufficientPermission;
          for (const audience in subRoute.roles) {
            hasSufficientPermission = subRoute.roles[audience]?.every(
              (scope: string) => {
                return user.roles[audience]?.includes(scope);
              }
            );
          }
          if (hasSufficientPermission) {
            res.push(subRoute);
          }
        } else {
          res.push(subRoute);
        }
      }
    }
    return res;
  };

  const renderChildren = () => {
    const department = routes.find((r) => r.path === path) || { subRoutes: [] };

    let arrChildren = children;
    if (!Array.isArray(children)) {
      arrChildren = [children];
    }

    const subRouteFilteredByPath = department.subRoutes?.filter((subRoute) => {
      for (const child of arrChildren) {
        if (child.props.path === subRoute.path) {
          return true;
        }
      }
      return false;
    });

    const subRouteFilteredByRole = filterByRole(subRouteFilteredByPath || []);

    const accessibleRoutes = arrChildren.filter((child: any) => {
      for (const subRoute of subRouteFilteredByRole) {
        if (child.props.path === subRoute.path) {
          return true;
        }
      }
      return false;
    });

    return accessibleRoutes.map((child: any, i: number) => {
      return React.cloneElement(child, {
        key: i,
        path: path + child.props.path,
      });
    });
  };

  const routing = () => (
    <Switch>
      {renderChildren()}
      <Route component={Page.Error} path="*" />
    </Switch>
  );

  return routing();
}
